export default (config) => {
  const base = {
    locale: 'fa',
    rootUserName: '0000',
    homeUrl: '/dashboard',
    defaultPageSize: 10,
    calendars: ['jalali'],
    defaultCalendar: 'jalali',
    infinityTime: '2100-01-01T00:00:00Z',
    defaultScopeId: 1000,
    defaultCarLaborerIsMinimum: false,
    isCourierDataVisible: true,
    currency: {
      base: 'IRR',
      display: 'IRR',
      rates: {
        IRR: 1,
        Tomans: 10
      }
    },
    timeZone: {
      text: 'Asia/Tehran',
      value: '+03:30'
    },
    ui: {
      skeletonAnimation: 'wave'
    },
    leafletConfig: {
      apiKey: null,
      defaultLat: 35.6892,
      defaultLng: 51.389,
      defaultZoom: 13,
      maxZoom: 18,
      minZoom: 6,
      scrollZoom: false,
      markerPrimaryColor: '#0D8FAC',
      markerSecondaryColor: '#03b037',
      defaultTheme: 'LIGHT',
      styleUrlDark:
        'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
      styleUrlLight: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
      styleUrlSat:
        'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png'
    }
  }

  config = { ...config, ...base }
  return config
}
